import React from "react";
import { useHistory } from "react-router-dom";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";
import { getFailedScheduleDeviceListApi } from "@/apis/apiCollection";
import HasPermission from "@/components/commons/HasPermission";
import ScheduleTaskType from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskType";
import { formatDate } from "@/helpers/datetimeHandlers";
import ChipStatus from "@/components/ChipStatus";

export const DashboardFailedScheduleDeviceListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      footer,
      children,
      onCheckAll,
      onLoaded,
      getSearchParams
    },
    ref
  ) => {
    const { t } = useTranslation();

    const history = useHistory();

    const toDetail = e => {
      e.preventDefault();
      const url = new URL(e.target.href);
      history.push(url.pathname);
    };

    const columns = [
      // {
      //   data: row => {
      //     return `${row.deviceId},${row.alarmTemplateId},${row.alarmPolicyId}`;
      //   },
      //   type: "checkbox"
      // },
      {
        name: "deviceSerialNumber",
        data: "deviceSerialNumber",
        title: t({ defaultMessage: "设备SN" }),
        createdCell: (td, data, rowData) => {
          ReactRender(
            <HasPermission permission="Device Monitoring Detail">
              {yes =>
                yes ? (
                  <a
                    href={`/device-list/device-detail/${rowData.deviceId}/${
                      rowData.os_type || "android"
                    }`}
                    onClick={toDetail}
                  >
                    {data}
                  </a>
                ) : (
                  data
                )
              }
            </HasPermission>,
            td
          );
        }
      },
      {
        data: "deviceName",
        orderable: false,
        title: t({ defaultMessage: "设备名称" })
      },
      {
        data: "deviceDetail",
        orderable: false,
        title: t({ defaultMessage: "描述" })
      },
      {
        name: "groups",
        orderable: false,
        data: row => {
          return row.groups.map(item => item.name).join(", ");
        },
        title: `${t({ defaultMessage: "门店" })}`
      },
      {
        name: "tags",
        orderable: false,
        data: row => {
          return row.tags.map(item => item.name).join(", ");
        },
        title: t({ defaultMessage: "标签" })
      },
      {
        data: "companies",
        orderable: false,
        title: `${t({ defaultMessage: "拥有者" })}`,
        data: row => {
          return row.companies.map(item => item.name).join(", ");
        }
      },
      {
        data: "deviceStatus",
        orderable: false,
        title: t({ defaultMessage: "设备状态" }),
        createdCell: (td, data) => {
          ReactRender(
            <ChipStatus
              type={data === 0 ? "success" : "default"}
              label={
                data === 0
                  ? t({ defaultMessage: "在线" })
                  : t({ defaultMessage: "离线" })
              }
            />,
            td
          );
        }
      },
      {
        data: "scheduleTemplateName",
        orderable: false,
        title: t({ defaultMessage: "排程模板" })
      },
      {
        data: "taskType",
        orderable: false,
        title: t({ defaultMessage: "排程任务" }),
        createdCell: (td, data, rowData) => {
          ReactRender(<ScheduleTaskType data={rowData} />, td);
        }
      },
      {
        data: "executedAt",
        orderable: false,
        title: t({ defaultMessage: "预计执行时间" }),
        render: data => {
          return formatDate(data, "YYYY-MM-DD HH:mm", "-", true);
        }
      }
    ];

    const ajax = (data, callback) => {
      return getFailedScheduleDeviceListApi({
        ...data,
        ...getSearchParams(),
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.failedScheduledDevices,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        scrollable
        // options={{ pageLength: 10 }}
        columns={columns}
        ajax={ajax}
        className={className}
        footer={footer}
        showFooter={false}
        showCheckAll={false}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
        style={{ height: 413, overflow: "hidden", flex: "none", ...style }}
      >
        {children}
      </DataTable>
    );
  }
);
